import { render, staticRenderFns } from "./privilegeConfig.vue?vue&type=template&id=20ec7540&scoped=true&"
import script from "./privilegeConfig.vue?vue&type=script&lang=js&"
export * from "./privilegeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec7540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ec7540')) {
      api.createRecord('20ec7540', component.options)
    } else {
      api.reload('20ec7540', component.options)
    }
    module.hot.accept("./privilegeConfig.vue?vue&type=template&id=20ec7540&scoped=true&", function () {
      api.rerender('20ec7540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/privilegeConfig.vue"
export default component.exports